var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 5.83337L8.47076 10.5962C9.02173 10.9819 9.29722 11.1748 9.59688 11.2495C9.86157 11.3154 10.1384 11.3154 10.4031 11.2495C10.7028 11.1748 10.9782 10.9819 11.5292 10.5962L18.3333 5.83337M5.66666 16.6667H14.3333C15.7335 16.6667 16.4335 16.6667 16.9683 16.3942C17.4387 16.1545 17.8212 15.7721 18.0608 15.3017C18.3333 14.7669 18.3333 14.0668 18.3333 12.6667V7.33337C18.3333 5.93324 18.3333 5.23318 18.0608 4.6984C17.8212 4.22799 17.4387 3.84554 16.9683 3.60586C16.4335 3.33337 15.7335 3.33337 14.3333 3.33337H5.66666C4.26653 3.33337 3.56646 3.33337 3.03168 3.60586C2.56128 3.84554 2.17882 4.22799 1.93914 4.6984C1.66666 5.23318 1.66666 5.93324 1.66666 7.33337V12.6667C1.66666 14.0668 1.66666 14.7669 1.93914 15.3017C2.17882 15.7721 2.56128 16.1545 3.03168 16.3942C3.56646 16.6667 4.26653 16.6667 5.66666 16.6667Z",
    stroke: "#818181",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.c9bbf24a2f9ca469ac7b5e31389f70cd.svg";
export { ForwardRef as ReactComponent };